// Backing store is a mutable object so downstream tests can use
// vi.spyOn(FEATURES, 'MINIGAMES_ENABLED', 'get').mockReturnValue(true)
// without "Cannot redefine property" errors that arise from plain `as const`.
const _defaults = {
  MINIGAMES_ENABLED: true,
  MINIGAMES_AVAILABLE: [
    'animal-count',
    'gift-grab',
    'quick-draw',
    'slippery-sprint',
    'explosive-exchange',
    'laser-leap',
    'crown-capture',
    'bouncing-balls',
  ] as readonly string[],
};

export const FEATURES = {
  get MINIGAMES_ENABLED(): boolean {
    return _defaults.MINIGAMES_ENABLED;
  },
  get MINIGAMES_AVAILABLE(): readonly string[] {
    return _defaults.MINIGAMES_AVAILABLE;
  },
} as const;

export type MinigameId = string;

/**
 * Predicate: is the given minigame id currently enabled?
 * Returns true only when both MINIGAMES_ENABLED is true AND the id is in
 * MINIGAMES_AVAILABLE. Coupling sites use this single predicate so future
 * additions to MINIGAMES_AVAILABLE flip behaviour without per-call surgery.
 */
export function isMinigameEnabled(id: string): boolean {
  return FEATURES.MINIGAMES_ENABLED && FEATURES.MINIGAMES_AVAILABLE.includes(id);
}
